import {Component, inject, Input, OnInit} from '@angular/core';
import {getLayoutMode} from '@app/store/layouts/layout-selector';
import {Store} from '@ngrx/store';
import {ValueSuffixPipe} from '@shared/pipes/unit-format.pipe';
import {SkeletonModule} from '@primeng/skeleton';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import { NgIf } from '@angular/common';

@Component({
  selector: 'card',
  standalone: true,
  imports: [
    ValueSuffixPipe,
    SkeletonModule,
    NgbPopover,
    NgIf
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss'
})
export class CardComponent implements OnInit {
  @Input() type: string;
  @Input() icon: string;
  @Input() title: string;
  @Input() value: any;
  @Input() valueType: string;
  @Input() subtext: string;
  @Input() profitType: number;
  @Input() profit: string;
  @Input() period: string;
  @Input() iconColor: string = 'primary';
  @Input() isLoading: any = false;
  @Input() popoverTitle:string
  @Input() valuePopover:string
  @Input() popoverDesc:string
  @Input() valueLeft: any
  @Input() valueRight: any
  @Input() percentRight: any
  @Input() percentLeft: any
  @Input() subTitle: string
  @Input() cardClass: string;
  @Input() subtextLeft: string;
  @Input() subtextRight: string;
  private store = inject(Store);

  mode: string;

  ngOnInit(): void {
    this.store.select(getLayoutMode).subscribe((mode) => {
      this.mode = mode;
    })
  }

  getProfitStyle(profitType = 1) {
    let border, background, color;

    if (profitType == 1) {
      border = '1px solid var(--in-primary)';
      color = 'var(--in-primary)';
      background = this.mode === 'light' ? '#EAFFF1' : '';
    } else {
      border = '1px solid ' + (this.mode === 'dark' ? 'var(--in-danger)' : '#FEC6D4');
      color = this.mode === 'dark' ? 'var(--in-danger)' : 'var(--in-danger)';
      background = this.mode === 'light' ? '#FFEEF3' : '';
    }

    return { border, background, color }
  }
}
